module.exports = __webpack_public_path__ + "media/images/logo-icon-bd38183d.png";